import { render, staticRenderFns } from "./IconCaretDouble.vue?vue&type=template&id=0fe82046"
import script from "./IconCaretDouble.vue?vue&type=script&lang=js"
export * from "./IconCaretDouble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports